import NumberFlow from "@number-flow/react"
import { Badge, Flex, Space, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import { RoutesPaths } from "../../constants/user-routes"
import { useAnimatedNumber } from "../../hooks/useAnimatedNumber"
import Icon from "../../Icon"
import Images from "../../Images"
import utils, { enrollmentStatusMap, serviceImgGray } from "../../Utils/utils"

import "./styles.less"

const { Text } = Typography

const FilterCard = ({ data, onClick, isActive, theme, isAdmin, isMobile, ...props }) => {
  const { t } = useTranslation()
  const animatedValue = useAnimatedNumber(data.value)

  const handleClick = () => {
    if (!data.isConnected) return
    onClick(data.id)
  }

  return (
    <Flex
      vertical
      gap={4}
      justify="center"
      className={cls("filter-card", {
        "filter-card-active": isActive,
        disabled: !data.isConnected
      })}
      onClick={handleClick}
    >
      <Flex gap={4} vertical>
        <Flex gap={8} align="center">
          <Text type="secondary" strong style={{ margin: 0, fontSize: 14 }}>
            {isMobile && data.shortName ? data.shortName : data.name}
          </Text>
          {data.img && !isMobile && (
            <img
              width={20}
              height={20}
              src={Images[serviceImgGray?.[theme]?.[data?.img]]}
              alt={data?.img}
            />
          )}
          {!isMobile && <Text type="secondary">{utils.toUpperLatter(data?.brand)}</Text>}
          {!isMobile && (
            <Space size={4} style={{ marginLeft: "auto" }}>
              {data?.status && !isAdmin && (
                <Link to={RoutesPaths.configure.enrollment}>
                  <Icon
                    type="settings"
                    color={theme === "light" ? "#000" : "#fff"}
                    style={{ fontSize: 20 }}
                  />
                </Link>
              )}
              {!data.isConnected && (
                <Link to={RoutesPaths.configure.enrollment} style={{ padding: 0 }}>
                  <Icon type="plus_large" style={{ fontSize: 20 }} />
                </Link>
              )}
            </Space>
          )}
        </Flex>
        <Flex gap={8} align="end">
          {/* Alert counts per provider are not sensitive — they stay visible in Incognito mode
              (CHA1-1352). */}
          <Text style={{ fontSize: !isMobile ? 24 : 16, lineHeight: 1.4 }}>
            <NumberFlow value={animatedValue} format={{ maximumFractionDigits: 0 }} />
          </Text>
          {data?.status && !isAdmin ? (
            <Flex style={{ marginLeft: "auto" }}>
              <Space size={16} direction="vertical" align="end">
                {!isMobile && (
                  <Flex gap={10} align="center" className={`status-tag status-tag-${data?.status}`}>
                    <Badge color={enrollmentStatusMap[data?.status]?.color} />
                    <Text
                      className="status-text"
                      style={{
                        color: enrollmentStatusMap[data?.status]?.color
                      }}
                      type="secondary"
                    >
                      {enrollmentStatusMap[data?.status]?.altText ??
                        enrollmentStatusMap[data?.status]?.text}
                    </Text>
                  </Flex>
                )}
              </Space>
            </Flex>
          ) : null}
        </Flex>
      </Flex>
    </Flex>
  )
}

export default FilterCard
